<div class="modal-header">
  <h4 class="modal-title">Add Event</h4>
</div>
@if (calendarEvent) {
  <div class="modal-body">
    <dx-form [formData]="calendarEvent" [colCount]="2">
      <dxi-item dataField="eventDate" [label]="{ text: 'Date' }"></dxi-item>
      <dxi-item itemType="empty"></dxi-item>
      <dxi-item dataField="name" [label]="{ text: 'Name' }" [colSpan]="2"></dxi-item>
      <dxi-item [label]="{ text: 'Description' }" [colSpan]="2">
        <div *dxTemplate>
          <dx-text-area [(value)]="calendarEvent.description" [height]="150"> </dx-text-area>
        </div>
      </dxi-item>
      <dxi-item [label]="{ text: 'Location' }">
        <div *dxTemplate>
          <dx-select-box
            [(value)]="calendarEvent.location"
            [dataSource]="eventLocations"
            valueExpr="name"
            displayExpr="name"
            [searchEnabled]="true"
            [showClearButton]="true"
          ></dx-select-box>
        </div>
      </dxi-item>
      <dxi-item [label]="{ text: 'Type' }">
        <div *dxTemplate>
          <dx-select-box
            [(value)]="calendarEvent.typeId"
            [dataSource]="eventTypes"
            valueExpr="id"
            displayExpr="name"
            [searchEnabled]="true"
            [showClearButton]="true"
          ></dx-select-box>
        </div>
      </dxi-item>
      <dxi-item dataField="privateEvent" [label]="{ text: 'Private' }" editorType="dxCheckBox"></dxi-item>
      <dxi-item itemType="empty"></dxi-item>
      <dxi-item [label]="{ text: 'All Day' }">
        <div *dxTemplate>
          <dx-check-box [(value)]="allDay" (onValueChanged)="allDayChanged($event)"></dx-check-box>
        </div>
      </dxi-item>
      <dxi-item itemType="empty"></dxi-item>
      <!-- <dxi-item dataField="startTime" [label]="{ text: 'Start' }" editorType="dxDateBox" [editorOptions]="{ type: 'time' }"></dxi-item> -->
      @if (calendarEvent) {
        <dxi-item [label]="{ text: 'Start Time' }">
          <div *dxTemplate>
            <dx-date-box
              [(value)]="calendarEvent.startTime"
              [type]="'time'"
              (onValueChanged)="startTimeChanged($event)"
            ></dx-date-box>
          </div>
        </dxi-item>
      }
      <dxi-item dataField="endTime" [label]="{ text: 'End' }" editorType="dxDateBox" [editorOptions]="{ type: 'time' }"></dxi-item>
      <dxi-item [label]="{ text: 'Private Notes' }" [colSpan]="2">
        <div *dxTemplate>
          <dx-text-area [(value)]="calendarEvent.officeInformation" [height]="200"> </dx-text-area>
        </div>
      </dxi-item>
      <dxi-item dataField="contactPerson" [label]="{ text: 'Contact Person' }" [colSpan]="2"></dxi-item>
      <dxi-item dataField="price" [label]="{ text: 'Price' }" editorType="dxNumberBox" [editorOptions]="{format:{type: 'currency', precision: 2}}"  [colSpan]="1"></dxi-item>
    </dx-form>
  </div>
}
<div class="modal-footer">
  <button class="btn btn-primary" (click)="save()" [disabled]="processing">Save</button>
  <button class="btn btn-light" (click)="close()">Cancel</button>
</div>
